<template>
  <div class="outerCtn">
    <img src="../../../assets/phoneCloseCM/banner1.png" alt="" width="100%" />
    <div class="mytabs" :style="{ top: hideHeight ? '0' : '280px' }">
      <div
        v-for="(item, index) in tabs"
        :key="item.key"
        :style="{
          color: item.isActive ? '#3170FF' : '#FFF',
          borderBottom: item.isActive ? '2px solid #3170FF' : 'none',
        }"
        @click="changeActive(index)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="article" v-if="activeIndex == 0">
      <p>公司介绍</p>
      <div class="imgCtn">
        <img src="@/assets/home_line.png" alt="" srcset="" />
      </div>
      <div class="detail">
        <p>
          辰鳗科技集团，全球优秀的综合能源服务商，自2020年创立以来，以能源科技研发创新为驱动，致力于服务全球工商业电力用户。以集团总部成都——云枢大脑中心、华东总部杭州——AI算法中心，为两大核心动力枢纽，为中国大陆工商电力用户提供全生命周期能源管理服务。同时，集团充分发挥南京、天津、长沙、北京、广州、拉萨、杭州等控股公司的区域优势与资源效能，织就一张覆盖全国，运转高效的业务服务网络，实现能源管理业务在中国范围内的客户服务与运维保障。
        </p>
        <p>
          截至2025年底，业务版图已成功延伸至全球6个国家、243座城市，累计服务工商业电力用户数量25.77万户。下一步，集团将依托“产品+AI”服务能力，在2030年全国电力统一市场全面建成前，完成国内所有省份的电力市场规则深度学习和匹配，致力于提升云枢平台的通用性与针对性，在预测和交易相关算法的mAP准确率达到95%以上；推动新能源资产和负荷侧资源的代运营体量实现指数级增长；积极布局国际市场，针对国际上存在开放电力市场的国家，开展针对性的训练与落地应用工作。
        </p>
        <p>
          秉持“每一度，我们在服务”的企业使命，辰鳗科技集团深度聚焦综合能源服务领域。依托集团旗下自主研发的小鳗鱼云枢星能智控平台，通过人工智能、物联网、多源异构能源算法、双碳能源管控等技术，从源网荷储碳投建运一体化、新能源光储资产代运营和全国电力市场交易服务三大核心板块精准发力，积极探索公建、工业、商业等多领域绿色转型的创新路径与全新方向，为行业绿色发展注入源源不断的动力。
        </p>

        <p>
          在源网荷储碳投建运一体化方面，涵盖零碳园区、工厂、区域微电网、虚拟电厂、分布式光伏、储能投建、节能技术服务、能源AI平台等多元业务实现区域绿色转型，参与园区能源资产长期运营；在新能源光储资产代运营板块，涉及电力市场运营业务、绿电交易、绿能替代、需求侧响应等关键服务，最大化实现新能源资产的价值；在全国电力市场交易服务领域，提供电力市场AI现货预测、出清、电能量交易全生命周期服务、辅助服务配套等技术。
        </p>
        <p>
          展望未来，辰鳗科技集团将以全球化为翼，以高质量发展为基，不断深化技术革新，积极拓宽服务领域，携手全球各地的合作伙伴，共同推动全球能源结构性转型与绿色低碳发展，为构建一个更加智慧、高效、可持续的零碳能源生态贡献辰鳗力量！
        </p>
      </div>
      <p style="margin-top: 40px">联系我们</p>
      <div class="imgCtn">
        <img src="@/assets/home_line.png" alt="" srcset="" />
      </div>
      <div class="detail" style="padding: 10px 0">
        <div class="eachItem" style="margin-top: 20px">
          <p>客服电话：</p>
          <p>028-86533354</p>
        </div>
        <div class="eachItem">
          <p>客服时间：</p>
          <p>09:00-18:00</p>
        </div>
        <div class="eachItem">
          <p>商业合作邮箱：</p>
          <p style="word-break: break-all">xiaomanguanjia@smalleel.com</p>
        </div>
        <div class="eachItem">
          <p>公司地址：</p>
          <p>四川省成都市双流区电子科大科技园B12栋四单元4F-6F</p>
        </div>
      </div>
      <img
        src="../../../assets/phoneCloseCM/map.png"
        alt=""
        width="100%"
        style="margin: 16px 0"
      />
      <div class="erweima">
        <div>
          <img src="../../../assets/phoneCloseCM/img1.png" alt="" width="70px" />
          <p>小鳗科技</p>
        </div>
        <div>
          <img src="../../../assets/phoneCloseCM/img2.png" alt="" width="70px" />
          <p>小鳗管家</p>
        </div>
      </div>
    </div>
    <div class="article" v-if="activeIndex == 1">
      <img src="../../../assets/phoneCloseCM/Bg.png" alt="" width="100%" />
    </div>
    <div class="article" v-if="activeIndex == 2">
      <p>知识产权</p>
      <div class="imgCtn">
        <img src="@/assets/home_line.png" alt="" srcset="" />
      </div>

      <div class="detail">
        <p style="margin-bottom: 20px">高新技术企业证书</p>
        <div height="325px" arrow="always">
          <div v-for="(item, index) in 1" :key="index" class="adjust">
            <img :src="gximgpage" alt="" srcset="" width="80%" />
            <p>高新技术企业证书</p>
          </div>
        </div>
      </div>

      <div class="detail">
        <p style="margin-bottom: 20px">产品专利证书</p>
        <el-carousel height="325px" arrow="always">
          <el-carousel-item v-for="(item, index) in cpzlData" :key="index" class="adjust">
            <img :src="item.url" alt="" srcset="" width="50%" />
            <p>
              {{ item.desc }}
            </p>
            <div>
              {{ item.desc1 }}
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="detail">
        <p style="margin-bottom: 20px">软件著作权</p>
        <el-carousel height="325px" arrow="always">
          <el-carousel-item v-for="(item, index) in rjzzData" :key="index" class="adjust">
            <img :src="item.url" alt="" srcset="" width="50%" />
            <p>
              {{ item.desc }}
            </p>
            <div>
              {{ item.desc1 }}
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="detail">
        <p style="margin-bottom: 20px">产品型号证书</p>
        <el-carousel height="325px" arrow="always">
          <el-carousel-item v-for="(item, index) in cpxhData" :key="index" class="adjust">
            <img :src="item.url" alt="" srcset="" width="50%" />
            <p>
              {{ item.desc }}
            </p>
            <div>
              {{ item.desc1 }}
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="detail">
        <p style="margin-bottom: 20px">质量管理证书</p>
        <el-carousel height="325px" arrow="always">
          <el-carousel-item v-for="(item, index) in zlglData" :key="index" class="adjust">
            <img :src="item.url" alt="" srcset="" width="50%" />
            <p>
              {{ item.desc }}
            </p>
            <div>
              {{ item.desc1 }}
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="article" v-if="activeIndex == 3">
      <p>合作伙伴</p>
      <div class="imgCtn">
        <img src="@/assets/home_line.png" alt="" srcset="" />
      </div>
      <div class="detail" style="padding-bottom: 50px">
        <img src="../../../assets/phoneCloseCM/pa.png" alt="" width="100%" />
      </div>
    </div>
  </div>
</template>

<script>
import cpzl1 from "../../../assets/phoneCloseCM/cpzl/1.jpg";
import cpzl2 from "../../../assets/phoneCloseCM/cpzl/2.jpg";
import cpxh1 from "../../../assets/phoneCloseCM/cpxh/1.jpg";
import cpxh2 from "../../../assets/phoneCloseCM/cpxh/2.jpg";
import cpxh3 from "../../../assets/phoneCloseCM/cpxh/3.jpg";
import cpxh4 from "../../../assets/phoneCloseCM/cpxh/4.jpg";
import zlgl1 from "../../../assets/phoneCloseCM/zlgl/1.jpg";
import zlgl2 from "../../../assets/phoneCloseCM/zlgl/2.jpg";
import zlgl3 from "../../../assets/phoneCloseCM/zlgl/3.jpg";
import rjzz124 from "../../../assets/phoneCloseCM/rjzz/124.jpg";
import rjzz134 from "../../../assets/phoneCloseCM/rjzz/134.jpg";
import rjzz197 from "../../../assets/phoneCloseCM/rjzz/197.jpg";
import rjzz319 from "../../../assets/phoneCloseCM/rjzz/319.jpg";
import rjzz321 from "../../../assets/phoneCloseCM/rjzz/321.jpg";
import rjzz322 from "../../../assets/phoneCloseCM/rjzz/322.jpg";
import rjzz587 from "../../../assets/phoneCloseCM/rjzz/587.jpg";
import rjzz590 from "../../../assets/phoneCloseCM/rjzz/590.jpg";
import rjzz591 from "../../../assets/phoneCloseCM/rjzz/591.jpg";
import rjzz759 from "../../../assets/phoneCloseCM/rjzz/759.jpg";
import rjzz807 from "../../../assets/phoneCloseCM/rjzz/807.jpg";
import rjzz855 from "../../../assets/phoneCloseCM/rjzz/855.jpg";
import rjzz884 from "../../../assets/phoneCloseCM/rjzz/884.jpg";
import rjzz891 from "../../../assets/phoneCloseCM/rjzz/891.jpg";
import rjzz892 from "../../../assets/phoneCloseCM/rjzz/892.jpg";
import gximg from "../../../assets/service/gx.png";

export default {
  data() {
    return {
      gximgpage: gximg,
      tabs: [
        { name: "公司介绍", key: 1, isActive: true },
        { name: "发展历程", key: 2, isActive: false },
        { name: "知识产权", key: 3, isActive: false },
        { name: "合作伙伴", key: 4, isActive: false },
      ],
      activeIndex: 0,
      cpzlData: [
        {
          url: cpzl2,
          desc: "一种带有能耗异常告警的智能电表",
          desc1: "CN217587346U 实用新型",
        },
        {
          url: cpzl1,
          desc: "一种带有防窃电功能的智能电表",
          desc1: "CN217587359U 实用新型",
        },
      ],
      cpxhData: [
        { url: cpxh1, desc: "单相电子式电能表(导轨)", desc1: "DDSU6610" },
        { url: cpxh2, desc: "单相电子式预付费电能表", desc1: "DDSY6610" },
        { url: cpxh3, desc: "三相四线电子式电能表(导轨)", desc1: "DTSU6610" },
        { url: cpxh4, desc: "三相四线电子式预付费电能表", desc1: "DTSY6610" },
      ],
      zlglData: [
        { url: zlgl1, desc: "质量管理体系认证证书", desc1: "41922Q00187-04R0S" },
        { url: zlgl2, desc: "环境管理体系认证证书", desc1: "41922E00115-04R0S" },
        { url: zlgl3, desc: "职业健康安全管理体系认证证书", desc1: "41922S00115-04R0S" },
      ],
      rjzzData: [
        {
          url: rjzz124,
          desc: "小鳗智能设备实时能耗监测管控平台",
          desc1: "2022SR0667124",
        },
        { url: rjzz134, desc: "小鳗物业系统", desc1: "2022SR0529134" },
        { url: rjzz197, desc: "小鳗商户系统", desc1: "2022SR0525197" },
        { url: rjzz319, desc: "小鳗平台管理系统", desc1: "2022SR0530319" },
        { url: rjzz321, desc: "小鳗管家收费智能云平台", desc1: "2022SR0530321" },
        { url: rjzz322, desc: "小鳗企业管理系统", desc1: "2022SR0530322" },
        {
          url: rjzz587,
          desc: "小鳗智能设备终端信息交互控制管理系统",
          desc1: "2022SR0654587",
        },
        { url: rjzz590, desc: "小鳗智能设备故障预警管理软件", desc1: "2022SR0654590" },
        {
          url: rjzz591,
          desc: "小鳗智能设备能耗数据在线监测预警分析系统",
          desc1: "2022SR0654591",
        },
        { url: rjzz759, desc: "小鳗智能设备定时控制系统", desc1: "2022SR0569759" },
        {
          url: rjzz807,
          desc: "小鳗智能设备远程物联信息化管理软件",
          desc1: "2022SR0665807",
        },
        { url: rjzz855, desc: "小鳗分润系统", desc1: "2022SR0569855" },
        { url: rjzz884, desc: "小鳗智能设备数据监控采集系统", desc1: "2022SR0557884" },
        { url: rjzz891, desc: "小鳗费用管理系统", desc1: "2022SR0569891" },
        { url: rjzz892, desc: "小鳗开放平台系统", desc1: "2022SR0569892" },
      ],
      hideHeight: false,
    };
  },
  methods: {
    changeActive(index) {
      for (let i = 0; i < this.tabs.length; i++) {
        if (index == i) {
          this.tabs[i].isActive = true;
        } else {
          this.tabs[i].isActive = false;
        }
      }
      this.activeIndex = index;
    },
  },
  mounted() {
    window.onscroll = () => {
      if (document.documentElement.scrollTop == 0 || document.body.scrollTop == 0) {
        this.hideHeight = false;
      }
      if (document.documentElement.scrollTop > 50 || document.body.scrollTop > 50) {
        this.hideHeight = true;
      }
    };
  },
};
</script>

<style lang="scss" scoped>
.mytabs {
  display: flex;
  justify-content: space-between;
  padding: 0 14px;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  padding-top: 19px;
  height: 50px;
  border-radius: 4px;
  width: 100%;
  position: fixed;
  left: 0;
  background-color: #24282e;
  z-index: 999;
}
.outerCtn {
  background-color: #24282e;
  color: white;
  min-height: 100vh;
  .article {
    margin: 40px 20px 0 20px;
    padding-bottom: 10px;
    padding-top: 60px;
    text-align: left;
    p {
      font-size: 20px;
      font-family: Alibaba PuHuiTi;
      font-weight: normal;
      padding-bottom: 10px;
      text-align: center;
      letter-spacing: 3px;
    }
    .imgCtn {
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      img {
        width: 84px;
        height: 3px;
      }
    }
  }
  .detail {
    background-color: #2d2f33;
    margin-top: 20px;
    border-radius: 4px;
    overflow: hidden;
    padding: 26px 20px;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    div {
      font-size: 12px;
      margin-bottom: 20px;
      line-height: 20px;
      letter-spacing: 1px;
    }
    .eachItem {
      display: flex;
      padding-left: 20px;
      margin: 4px 0;
      p {
        font-size: 12px;
        padding-bottom: 0;
        text-align: left;
        text-indent: 0cm;
        line-height: 20px;
        letter-spacing: 1px;
      }
    }
    .eachItem p:nth-child(2) {
      max-width: 210px;
      color: #4a81ff;
    }
    .adjust {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      p {
        font-size: 12px;
        margin-top: 20px;
      }
    }
  }
  .erweima {
    display: flex;
    justify-content: space-around;
    width: 60%;
    margin: auto;
    p {
      font-size: 12px;
      margin-top: 12px;
      color: #3170ff;
    }
  }
}
</style>
<style>
.detail .el-carousel__indicator--horizontal {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/page/phone/phoneCloseCM.vue